import { Durations } from '@/constants/durations'
import { NextPageWithLayout } from '@/layouts'
import { LegalLayout } from '@/layouts/LegalLayout'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import { Privacy_2025_03_18 } from './2025-03-18'

const PrivacyPage: NextPageWithLayout = () => {
  return <Privacy_2025_03_18 />
}

PrivacyPage.getLayout = (page) => {
  return <LegalLayout>{page}</LegalLayout>
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/legal/privacy/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'account'])),
      },
      revalidate: Durations.ONE_YEAR_IN_SECONDS,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

export default PrivacyPage
